"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = exports.FileUploadContainer = void 0;
var js_1 = require("@mdi/js");
var react_1 = require("@mdi/react");
var react_2 = __importStar(require("react"));
var storage_1 = require("react-firebase-hooks/storage");
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../..");
exports.FileUploadContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px dashed #000;\n  border-radius: 4px;\n  min-height: 200px;\n  max-height: 200px;\n  position: relative;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px dashed #000;\n  border-radius: 4px;\n  min-height: 200px;\n  max-height: 200px;\n  position: relative;\n  ", "\n"])), function (_a) {
    var isDragging = _a.isDragging;
    return isDragging && "background-color: #f0f0f0;";
});
var HiddenInput = styled_components_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var FileUpload = function (_a) {
    var onFileUpload = _a.onFileUpload, next = _a.next, _b = _a.accept, accept = _b === void 0 ? [".json"] : _b, _c = _a.multiple, multiple = _c === void 0 ? false : _c, customIcon = _a.customIcon, intel = _a.intel, path = _a.path, data = _a.data, dbMirror = _a.dbMirror;
    var _d = (0, __1.useEloise)(), logic = _d.logic, fireBaseConfig = _d.fireBaseConfig;
    var _e = (0, storage_1.useUploadFile)(), uploadFile = _e[0], uploading = _e[1], snapshot = _e[2], error = _e[3];
    var _f = (0, react_2.useState)(false), isDragging = _f[0], setIsDragging = _f[1];
    var fileInputRef = (0, react_2.useRef)(null);
    var handleDragEnter = (0, react_2.useCallback)(function (event) {
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(true);
    }, []);
    var handleDragOver = (0, react_2.useCallback)(function (event) {
        event.preventDefault();
        event.stopPropagation();
    }, []);
    var handleDragLeave = (0, react_2.useCallback)(function (event) {
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);
    }, []);
    var handleDrop = (0, react_2.useCallback)(function (event) {
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);
        processFiles(event.dataTransfer.files);
    }, []);
    var processFiles = (0, react_2.useCallback)(function (files) {
        var _a;
        for (var i = 0; i < files.length; i++) {
            var file = files.item(i);
            if (file) {
                var extension = ((_a = file.name.split(".").pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
                if (accept.includes(".".concat(extension))) {
                    if (onFileUpload) {
                        onFileUpload(file);
                    }
                    else {
                        handleFileUpload(file);
                    }
                }
            }
        }
    }, [accept]);
    var handleFileInputChange = function (event) {
        var files = event.target.files;
        if (files) {
            processFiles(files);
        }
    };
    var handleFileUpload = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var result, result2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, logic.fb.storageMethods.uploadFile(path, file)];
                case 1:
                    result = _a.sent();
                    if (!dbMirror) return [3 /*break*/, 3];
                    return [4 /*yield*/, logic.fb.docs.setUserDoc(path, data)];
                case 2:
                    result2 = _a.sent();
                    _a.label = 3;
                case 3:
                    if (typeof next === "function") {
                        next(result);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var openFileDialog = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (react_2.default.createElement(__1.EloiseWidget, { eloiseIntel: __assign({}, intel) },
        react_2.default.createElement(exports.FileUploadContainer, { isDragging: isDragging, onDragEnter: handleDragEnter, onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, onClick: openFileDialog },
            uploading ? (react_2.default.createElement(__1.Loading, null)) : snapshot ? (customIcon ? (react_2.default.createElement(react_2.default.Fragment, null, customIcon)) : (react_2.default.createElement(react_1.Icon, { path: js_1.mdiCheck, style: {
                    position: "absolute",
                    width: "50%",
                    height: "50%",
                    top: "25%",
                    left: "25%",
                } }))) : customIcon ? (react_2.default.createElement(react_2.default.Fragment, null, customIcon)) : (react_2.default.createElement(react_1.Icon, { path: js_1.mdiUpload, style: {
                    position: "absolute",
                    width: "50%",
                    height: "50%",
                    top: "25%",
                    left: "25%",
                } })),
            react_2.default.createElement(HiddenInput, { ref: fileInputRef, type: "file", accept: accept.join(","), onChange: handleFileInputChange, multiple: multiple }))));
};
exports.FileUpload = FileUpload;
var templateObject_1, templateObject_2;
